import { Modal, Button } from 'antd';
import { useGlobalModal } from 'hooks';
import MutationGridConfig from 'pages/home/ribbon/components/controls/home/grid-query/MutationGridConfig';

const CreateQueryModal = ({
  handleCreateConfig,
  statusCreate,
  form,
  setIsMounted,
  selectedMembers,
  setSelectedMembers,
  toggleCuratedQuery,
  setCuratedQuery,
  gridName,
  shareType,
  setShareType,
  memberRoles,
}) => {
  const { MODAL_NAMES, closeModal, checkModalVisible } = useGlobalModal();
  const visible = checkModalVisible(MODAL_NAMES.CREATE_QUERY);
  return (
    <>
      {visible && (
        <Modal
          title='Create Query'
          visible={visible}
          onOk={() => closeModal(MODAL_NAMES.CREATE_QUERY)}
          onCancel={() => closeModal(MODAL_NAMES.CREATE_QUERY)}
          destroyOnClose
          width={1100}
          bodyStyle={{
            maxHeight: '700px',
          }}
          maskClosable={false}
          className='modal-create-query'
          footer={[
            <Button
              key='save'
              type='primary'
              onClick={handleCreateConfig}
              loading={statusCreate === 'loading'}
            >
              Create
            </Button>,
          ]}
        >
          <MutationGridConfig
            form={form}
            setIsMounted={setIsMounted}
            renderDefault={false}
            selectedMembers={selectedMembers}
            setSelectedMembers={setSelectedMembers}
            toggleCuratedQuery={toggleCuratedQuery}
            setCuratedQuery={setCuratedQuery}
            gridName={gridName}
            shareType={shareType}
            setShareType={setShareType}
            memberRoles={memberRoles}
          />
        </Modal>
      )}
    </>
  );
};

export default CreateQueryModal;
